import React from 'react';

class AlertModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    this.setState({
      visible: this.props.Visible,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      visible: nextProps.Visible,
    });
  }

  render() {
    return (
      <div className={`modal ${this.state.visible ? 'modal--visible' : 'modal--hidden'}`}>
        <div className="modalHeader">{this.props.Title}</div>
        <div className="modalBody">
          <div className="modalBodyText">{this.props.BodyText}</div>
        </div>
        <div className="modalFooter">
          <button
            onClick={() => {
              this.setState({
                visible: false,
              });
              if (this.props.OnOk) this.props.OnOk();
            }}
            className="next-link"
          >
            Ok
          </button>
        </div>
      </div>
    );
  }
}

export { AlertModal };
